import React, { Component, Fragment } from 'react';
import { Link } from "react-router-dom";
class Pagenotfound extends Component {
    render() {
        return (
            <Fragment>
                <div id="not-found">
                    <div className="row">
                        <div className="col-md-12">
                            <h1 className="text-center text-danger">Página no encontrada</h1>
                            <p className="text-center">
                                <Link to="/" className="btn btn-info btn-lg">Volver a inicio</Link>
                            </p>
                        </div>
                    </div>
                </div>
            </Fragment>
        );
    }
}

export default Pagenotfound;


// WEBPACK FOOTER //
// ./src/components/notfound/Pagenotfound.js